/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import { UitkListItem } from 'uitk-react-list';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkSpacing } from 'uitk-react-spacing';
import { checkValue } from '../../../../helper';
import { FlightViewProps } from './types.d';
import { UitkCard, UitkCardContentSection } from 'uitk-react-cards';
import { UitkText } from 'uitk-react-text';
import { UitkFigure, UitkFigureAspectRatioType, UitkImage } from 'uitk-react-images';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkButtonSize, UitkPrimaryButton } from 'uitk-react-button';
 
export const FlightDealCard: React.FC<FlightViewProps> = (flightViewProps: FlightViewProps) => {
  const {
    departureAndArrivalLocations,
    airlines,
    departureAndArrivalTime,
    durationAndStops,
    layoverInformation,
    price,
    ctaCopy,
    keyIndex,
    tripType,
    urgencyMessage,
    flightButtonOnClick,
    flightURL,
  } = flightViewProps; 
  return (
    <>
      <UitkListItem key={`listitem-${keyIndex}`}>
        <div>
          <UitkCard>
            <UitkCardContentSection padded>
              <UitkLayoutGrid columns={['1fr', '1fr', '40x', '40x']} space="two">
                <UitkLayoutGridItem>
                  <UitkLayoutFlex direction="column">
                    <UitkLayoutGridItem>
                      <div className="arrival-time">
                        <UitkText align="left" size={400} weight="bold">
                          {departureAndArrivalTime}
                        </UitkText>
                      </div>
                    </UitkLayoutGridItem>

                    <UitkLayoutGridItem>
                      <UitkText align="left" size={200}>
                        {departureAndArrivalLocations}
                      </UitkText>
                    </UitkLayoutGridItem>
                    <UitkLayoutGridItem>
                      <UitkLayoutGrid columns={['5x', '1fr']} space="two">
                        <UitkLayoutGridItem>
                          <UitkFigure ratio={UitkFigureAspectRatioType.R1_1}>
                            <UitkImage placeholderImage={true} alt="alternative text" src={airlines[0]?.image?.url} />
                          </UitkFigure>
                        </UitkLayoutGridItem>
                        <UitkText align="left" size={200}>
                          {airlines?.[0]?.text}
                        </UitkText>
                        <UitkLayoutGridItem></UitkLayoutGridItem>
                      </UitkLayoutGrid>
                      <UitkText align="left" size={200}>
                        {departureAndArrivalLocations}
                      </UitkText>
                    </UitkLayoutGridItem>
                  </UitkLayoutFlex>
                </UitkLayoutGridItem>
                <UitkLayoutGridItem>
                  <UitkLayoutGridItem>
                    <UitkLayoutFlex alignItems="center" justifyContent="center" direction="column">
                      <UitkSpacing padding={{ inlineend: 'one' }}>
                        <UitkText align="left" size={200}>
                          {durationAndStops}
                        </UitkText>
                      </UitkSpacing>
                      <UitkText align="left" size={200}>
                        {layoverInformation}
                      </UitkText>
                    </UitkLayoutFlex>
                  </UitkLayoutGridItem>
                </UitkLayoutGridItem>
                <UitkLayoutGridItem>
                  <UitkLayoutFlex direction="column" justifyContent="center">
                    {checkValue(urgencyMessage) && (
                      <UitkLayoutFlexItem>
                        <UitkText align="center" size={200}>
                          {urgencyMessage}
                        </UitkText>
                      </UitkLayoutFlexItem>
                    )}
                    <UitkLayoutFlexItem>
                      <UitkText align="center" size={600} weight="bold">
                        {price}
                      </UitkText>
                    </UitkLayoutFlexItem>
                    <UitkLayoutFlexItem>
                      <UitkText align="center" size={200}>
                        {tripType}
                      </UitkText>
                    </UitkLayoutFlexItem>
                  </UitkLayoutFlex>
                </UitkLayoutGridItem>
                <UitkLayoutGridItem>
                  <UitkLayoutFlex direction="column" justifyContent="center">
                    <UitkLayoutFlexItem>
                      <UitkPrimaryButton
                        className={'show-more'}
                        name="showMoreButton"
                        type="button"
                        size={UitkButtonSize.LARGE}
                        onClick={flightButtonOnClick}
                        data-flight-url={flightURL}
                      >
                        {ctaCopy}
                      </UitkPrimaryButton>
                    </UitkLayoutFlexItem> 
                  </UitkLayoutFlex>
                </UitkLayoutGridItem>
              </UitkLayoutGrid>
            </UitkCardContentSection>
          </UitkCard>
        </div>
      </UitkListItem>
    </>
  );
};
